import { theme } from 'antd'
import { ThemeCommon } from './theme.common'
import { ThemeType } from './theme.config'

export const ThemeDark: ThemeType = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...ThemeCommon.token,
  },
  components: {},
  extra: {
    scrollbarColor: 'rgba(255, 255, 255, 0.2)',
    scrollbarColorHover: 'rgba(255, 255, 255, 0.3)',
    scrollbarColorActive: 'rgba(255, 255, 255, 0.4)',
  },
}
